import axios from '../axios-config';
import { StudentIncident } from '../types';

class StudentIncidentService {
  async getAll(): Promise<StudentIncident[]> {
    const res = await axios.get('/api/StudentIncidents');
    return res.data;
  }

  async create(data: Partial<StudentIncident>): Promise<StudentIncident> {
    const res = await axios.post('/api/StudentIncidents', data);
    return res.data;
  }

  async update(id: string, data: Partial<StudentIncident>): Promise<StudentIncident> {
    const res = await axios.put(`/api/StudentIncidents/${id}`, data);
    return res.data;
  }

  async delete(id: string): Promise<void> {
    await axios.delete(`/api/StudentIncidents/${id}`);
  }
}

export default new StudentIncidentService();
